import { PureComponent } from "react";

import {
    ButtonRow,
    ModalContainer,
    HeaderContainer,
    SelectionContainer,
    SelectionFieldset,
    OptionContainerWrapper,
    SelectionOptionContainer,
    SelectionOption,
    SelectionByline,
    SelectionIcon,
    ConfirmationContainer,
} from "./duplicate-app-modal-style";
import { withModalProvider } from "designer/modals-v2/modal-provider-v2/modal-provider-v2";
import { SimpleModalContextProps } from "designer/modals-v2/modal-provider-v2/modal-context";

import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";
export type DuplicateMethod = "dont" | "keep-sheet" | "new-sheet";

interface Props {
    appID: string;
    appTitle: string;
    appIcon: JSX.Element;
    onSelection: (method: DuplicateMethod) => void;
    modals: SimpleModalContextProps;
}

interface State {
    keepSheet: boolean;
}

class DuplicateAppModalWithClosing extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { keepSheet: true };
    }

    private onDuplicateClick = () => {
        const { onSelection } = this.props;
        const { keepSheet } = this.state;
        const method = keepSheet ? "keep-sheet" : "new-sheet";
        onSelection(method);
    };

    public render() {
        const { appTitle, appIcon, onSelection } = this.props;
        const { keepSheet } = this.state;
        return (
            <ModalContainer>
                <HeaderContainer>
                    {appIcon}
                    <span>
                        Duplicate <em>'{appTitle}'</em>
                    </span>
                </HeaderContainer>
                <SelectionContainer>
                    <SelectionFieldset>
                        <OptionContainerWrapper>
                            <SelectionOptionContainer>
                                <SelectionOption
                                    id="keep-sheet"
                                    type="radio"
                                    checked={keepSheet}
                                    onChange={() => {
                                        this.setState({ keepSheet: true });
                                    }}
                                />
                                <SelectionByline htmlFor="keep-sheet" selected={keepSheet}>
                                    Keep same sheet
                                </SelectionByline>
                                <SelectionIcon src="/images/keep-sheet.svg" />
                            </SelectionOptionContainer>
                        </OptionContainerWrapper>
                        <OptionContainerWrapper>
                            <SelectionOptionContainer>
                                <SelectionOption
                                    id="new-sheet"
                                    type="radio"
                                    checked={!keepSheet}
                                    onChange={() => {
                                        this.setState({ keepSheet: false });
                                    }}
                                />
                                <SelectionByline htmlFor="new-sheet" selected={!keepSheet}>
                                    Copy the sheet
                                </SelectionByline>
                                <SelectionIcon src="/images/copy-sheet.svg" />
                            </SelectionOptionContainer>
                        </OptionContainerWrapper>
                    </SelectionFieldset>
                </SelectionContainer>
                <ConfirmationContainer>
                    <ButtonRow>
                        <ButtonVNext
                            onClick={() => onSelection("dont")}
                            buttonType={"secondary"}
                            variant={"default"}
                            size={"md"}
                            label={"Cancel"}
                        />
                        <ButtonVNext
                            onClick={this.onDuplicateClick}
                            buttonType={"primary"}
                            variant={"default"}
                            size={"md"}
                            label={"Duplicate app"}
                        />
                    </ButtonRow>
                </ConfirmationContainer>
            </ModalContainer>
        );
    }
}

export const DuplicateAppModal = withModalProvider(DuplicateAppModalWithClosing);
